import { ReduxStateHandler } from '../ReduxStateHandler';

export const RequestFunnelConfigsStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_REQUESTED_CONFIGS',
  statePath: 'requestedConfigs',
});
